/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/orders/order
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import { shopifyCurrencyCodeEnumOptions } from "./constants";
import {
  ShopifyBalanceTransactionKey,
  ShopifyBalanceTransactionToOrderKey,
  ShopifyBusinessEntityKey,
  ShopifyCheckoutKey,
  ShopifyCheckoutToOrderKey,
  ShopifyCompanyContactKey,
  ShopifyCompanyKey,
  ShopifyCompanyLocationKey,
  ShopifyCustomerKey,
  ShopifyDisputeKey,
  ShopifyDisputeToOrderKey,
  ShopifyDraftOrderKey,
  ShopifyDraftOrderToOrderKey,
  ShopifyFulfillmentEventKey,
  ShopifyFulfillmentEventToOrderKey,
  ShopifyFulfillmentKey,
  ShopifyFulfillmentOrderKey,
  ShopifyFulfillmentOrderToOrderKey,
  ShopifyFulfillmentToOrderKey,
  ShopifyGiftCardKey,
  ShopifyGiftCardToOrderKey,
  ShopifyLocationKey,
  ShopifyOrderAdjustmentKey,
  ShopifyOrderAdjustmentToOrderKey,
  ShopifyOrderKey,
  ShopifyOrderLineItemKey,
  ShopifyOrderLineItemToOrderKey,
  ShopifyOrderRiskKey,
  ShopifyOrderRiskToOrderKey,
  ShopifyOrderToBalanceTransactionsKey,
  ShopifyOrderToBusinessEntityKey,
  ShopifyOrderToCheckoutsKey,
  ShopifyOrderToCompanyContactKey,
  ShopifyOrderToCompanyKey,
  ShopifyOrderToCompanyLocationKey,
  ShopifyOrderToCustomerKey,
  ShopifyOrderToDisputesKey,
  ShopifyOrderToDraftOrderKey,
  ShopifyOrderToFulfillmentEventsKey,
  ShopifyOrderToFulfillmentOrdersKey,
  ShopifyOrderToGiftCardsKey,
  ShopifyOrderToLocationKey,
  ShopifyOrderToOrderAdjustmentsKey,
  ShopifyOrderToOrderRisksKey,
  ShopifyOrderToRefundsKey,
  ShopifyOrderToRetailLocationKey,
  ShopifyOrderToReturnsKey,
  ShopifyOrderToReverseFulfillmentOrdersKey,
  ShopifyOrderToShopKey,
  ShopifyOrderToSubscriptionBillingAttemptKey,
  ShopifyOrderToSubscriptionContractKey,
  ShopifyOrderToTenderTransactionsKey,
  ShopifyOrderToTransactionsKey,
  ShopifyOrderTransactionKey,
  ShopifyOrderTransactionToOrderKey,
  ShopifyPaymentTermsKey,
  ShopifyPaymentTermsToOrderKey,
  ShopifyRefundKey,
  ShopifyRefundToOrderKey,
  ShopifyReturnKey,
  ShopifyReturnToOrderKey,
  ShopifyReverseFulfillmentOrderKey,
  ShopifyReverseFulfillmentOrderToOrderKey,
  ShopifyShippingLineKey,
  ShopifyShippingLineToOrderKey,
  ShopifyShopKey,
  ShopifySubscriptionBillingAttemptKey,
  ShopifySubscriptionBillingAttemptToOrderKey,
  ShopifySubscriptionContractKey,
  ShopifyTenderTransactionKey,
  ShopifyTenderTransactionToOrderKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyOrderKey,
  "2022-01": {
    name: "Shopify Order",
    hasMetafields: true,
    graphQLTypename: "Order",
    fields: [
      // {
      //   name: "App",
      //   fieldType: FieldType.BelongsTo,
      //   key: ShopifyOrderToAppKey,
      //   contributorConfiguration:  { [ShopifyDominion.id]: { shopifyFieldKey: "app_id" } },
      //   configuration: {
      //     relatedModelKey: ShopifyAppKey,
      //   },
      // },
      {
        name: "Adjustments",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToOrderAdjustmentsKey,
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyOrderAdjustmentKey,
          inverseFieldKey: ShopifyOrderAdjustmentToOrderKey,
        },
      },
      {
        name: "Balance Transactions",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToBalanceTransactionsKey,
        configuration: {
          relatedModelKey: ShopifyBalanceTransactionKey,
          inverseFieldKey: ShopifyBalanceTransactionToOrderKey,
        },
      },
      {
        name: "Billing Address",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "billing_address" } },
      },
      {
        name: "Browser IP",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "browser_ip" } },
      },
      {
        name: "Buyer Accepts Marketing",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "buyer_accepts_marketing" } },
      },
      {
        name: "Cancel Reason",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "cancel_reason" } },
      },
      {
        name: "Cancelled At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "cancelled_at" } },
      },
      {
        name: "Cart Token",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "cart_token" } },
      },
      {
        name: "Checkout Token",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "checkout_token" } },
      },
      {
        name: "Client Details",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "client_details" } },
      },
      {
        name: "Closed At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "closed_at" } },
      },
      {
        name: "Currency",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "currency" } },
      },
      {
        name: "Current Subtotal Price",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "current_subtotal_price" } },
      },
      {
        name: "Current Subtotal Price Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "current_subtotal_price_set" } },
      },
      {
        name: "Current Total Discounts",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "current_total_discounts" } },
      },
      {
        name: "Current Total Discounts Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "current_total_discounts_set" } },
      },
      {
        name: "Current Total Duties Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "current_total_duties_set" } },
      },
      {
        name: "Current Total Price",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "current_total_price" } },
      },
      {
        name: "Current Total Price Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "current_total_price_set" } },
      },
      {
        name: "Current Total Tax",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "current_total_tax" } },
      },
      {
        name: "Current Total Tax Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "current_total_tax_set" } },
      },
      {
        name: "Customer",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToCustomerKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "customer" } },
        configuration: {
          relatedModelKey: ShopifyCustomerKey,
        },
      },
      {
        name: "Customer Locale",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "customer_locale" } },
      },
      {
        name: "Discount Applications",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "discount_applications" } },
      },
      {
        name: "Discount Codes",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "discount_codes" } },
      },
      {
        name: "Disputes",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToDisputesKey,
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyDisputeKey,
          inverseFieldKey: ShopifyDisputeToOrderKey,
        },
      },
      {
        name: "Email",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "email" } },
      },
      {
        name: "Estimated Taxes",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "estimated_taxes" } },
      },
      {
        name: "Financial Status",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "financial_status" } },
      },
      {
        name: "Fulfillment Status",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "fulfillment_status" } },
      },
      {
        name: "Fulfillments",
        fieldType: FieldType.HasMany,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "fulfillments" } },
        configuration: {
          relatedModelKey: ShopifyFulfillmentKey,
          inverseFieldKey: ShopifyFulfillmentToOrderKey,
        },
      },
      {
        name: "Fulfillment Events",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToFulfillmentEventsKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentEventKey,
          inverseFieldKey: ShopifyFulfillmentEventToOrderKey,
        },
      },
      {
        name: "Fulfillment Orders",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToFulfillmentOrdersKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentOrderKey,
          inverseFieldKey: ShopifyFulfillmentOrderToOrderKey,
        },
      },
      {
        name: "Gateway",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "gateway" } },
      },
      {
        name: "Gift Cards",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToGiftCardsKey,
        configuration: {
          relatedModelKey: ShopifyGiftCardKey,
          inverseFieldKey: ShopifyGiftCardToOrderKey,
        },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Landing Site",
        fieldType: FieldType.URL,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "landing_site" } },
      },
      {
        name: "Line Items",
        fieldType: FieldType.HasMany,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "line_items" } },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyOrderLineItemKey,
          inverseFieldKey: ShopifyOrderLineItemToOrderKey,
        },
      },
      {
        name: "Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToLocationKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "location_id" } },
        configuration: {
          relatedModelKey: ShopifyLocationKey,
        },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "name" } },
      },
      {
        name: "Note",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "note" } },
      },
      {
        name: "Note Attributes",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "note_attributes" } },
      },
      {
        name: "Number",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "number" } },
      },
      {
        name: "Order Number",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "order_number" } },
      },
      {
        name: "Order Status URL",
        fieldType: FieldType.URL,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "order_status_url" } },
      },
      {
        name: "Original Total Duties Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "original_total_duties_set" } },
      },
      {
        name: "Payment Details",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "payment_details" } },
      },
      {
        name: "Payment Gateway Names",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "payment_gateway_names" } },
      },
      {
        name: "Phone",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "phone" } },
      },
      {
        name: "Presentment Currency",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "presentment_currency" } },
      },
      {
        name: "Processed At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "processed_at" } },
      },
      {
        name: "Processing Method",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "processing_method" } },
      },
      {
        name: "Referring Site",
        fieldType: FieldType.URL,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "referring_site" } },
      },
      {
        name: "Refunds",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToRefundsKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "refunds" } },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyRefundKey,
          inverseFieldKey: ShopifyRefundToOrderKey,
        },
      },
      {
        name: "Risks",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToOrderRisksKey,
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyOrderRiskKey,
          inverseFieldKey: ShopifyOrderRiskToOrderKey,
        },
      },
      {
        name: "Shipping Address",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shipping_address" } },
      },
      {
        name: "Shipping Lines",
        fieldType: FieldType.HasMany,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shipping_lines" } },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyShippingLineKey,
          inverseFieldKey: ShopifyShippingLineToOrderKey,
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at" } },
      },
      {
        name: "Source Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "source_name" } },
      },
      {
        name: "Subscription Billing Attempts",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToSubscriptionBillingAttemptKey,
        configuration: {
          relatedModelKey: ShopifySubscriptionBillingAttemptKey,
          inverseFieldKey: ShopifySubscriptionBillingAttemptToOrderKey,
        },
      },
      {
        name: "Subscription Contract",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToSubscriptionContractKey,
        configuration: {
          relatedModelKey: ShopifySubscriptionContractKey,
        },
      },
      {
        name: "Subtotal Price",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "subtotal_price" } },
      },
      {
        name: "Subtotal Price Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "subtotal_price_set" } },
      },
      {
        name: "Tags",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tags" } },
      },
      {
        name: "Tax Lines",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tax_lines" } },
      },
      {
        name: "Taxes Included",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "taxes_included" } },
      },
      {
        name: "Test",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "test" } },
      },
      {
        name: "Token",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "token" } },
      },
      {
        name: "Total Discounts",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "total_discounts" } },
      },
      {
        name: "Total Discounts Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "total_discounts_set" } },
      },
      {
        name: "Total Line Items Price",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "total_line_items_price" } },
      },
      {
        name: "Total Line Items Price Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "total_line_items_price_set" } },
      },
      {
        name: "Total Outstanding",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "total_outstanding" } },
      },
      {
        name: "Total Price",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "total_price" } },
      },
      {
        name: "Total Price Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "total_price_set" } },
      },
      {
        name: "Total Shipping Price Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "total_shipping_price_set" } },
      },
      {
        name: "Total Tax",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "total_tax" } },
      },
      {
        name: "Total Tax Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "total_tax_set" } },
      },
      {
        name: "Total Tip Received",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "total_tip_received" } },
      },
      {
        name: "Total Weight",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "total_weight" } },
      },
      {
        name: "Tender Transactions",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToTenderTransactionsKey,
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyTenderTransactionKey,
          inverseFieldKey: ShopifyTenderTransactionToOrderKey,
        },
      },
      {
        name: "Transactions",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToTransactionsKey,
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyOrderTransactionKey,
          inverseFieldKey: ShopifyOrderTransactionToOrderKey,
        },
      },
      // {
      //   name: "User",
      //   fieldType: FieldType.BelongsTo,
      //   key: ShopifyOrderToUserKey,
      //   contributorConfiguration:  { [ShopifyDominion.id]: { shopifyFieldKey: "user_id" } },
      //   configuration: {
      //     relatedModelKey: ShopifyUserKey,
      //   },
      // },
      {
        name: "Checkouts",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToCheckoutsKey,
        configuration: {
          relatedModelKey: ShopifyCheckoutKey,
          inverseFieldKey: ShopifyCheckoutToOrderKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "order" },
  },
  "2022-04": {
    fields: [
      {
        name: "Source Identifier",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "source_identifier" } },
      },
      {
        name: "Source URL",
        fieldType: FieldType.URL,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "source_url" } },
      },
    ],
  },
  "2022-10": {
    fields: [
      {
        name: "Merchant of Record App Id",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "merchant_of_record_app_id" } },
      },
    ],
  },
  "2023-04": {
    fields: [
      {
        name: "Current Total Additional Fees Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "current_total_additional_fees_set" },
        },
      },
      {
        name: "Original Total Additional Fees Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "original_total_additional_fees_set" },
        },
      },
      {
        name: "Additional Fees",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_additional_fees",
            graphQLFieldKey: "additionalFees",
            graphQLOnlyField: true,
            graphQLSelection: `
            id
            name
            price {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
            taxLines {
              channelLiable
              priceSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
                shopMoney {
                  amount
                  currencyCode
                }
              }
              rate
              ratePercentage
              title
            }`,
          },
        },
      },
      {
        name: "Gateway",
        fieldType: FieldType.String,
        isDeleted: true,
      },
      {
        name: "Payment Details",
        fieldType: FieldType.JSON,
        isDeleted: true,
      },
      {
        name: "Processing Method",
        fieldType: FieldType.String,
        isDeleted: true,
      },
      {
        name: "Purchasing Entity",
        fieldType: FieldType.JSON,
        shouldConvergeField: (enabledModelKeys) =>
          enabledModelKeys.some((key) => [ShopifyCompanyKey, ShopifyCompanyLocationKey, ShopifyCompanyContactKey].includes(key)),
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLOnlyField: true,
            shopifyFieldKey: "__gadget_graphql_purchasing_entity",
            graphQLFieldKey: "purchasingEntity",
            graphQLSelection: `
              ... on PurchasingCompany {
                company {
                  id
                }
                contact {
                  id
                }
                location {
                  id
                }
              }
              ... on Customer {
                id
              }
            `,
          },
        },
      },
      {
        name: "Purchasing Company",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToCompanyKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_purchasing_company",
          },
        },
        configuration: {
          relatedModelKey: ShopifyCompanyKey,
        },
      },
      {
        name: "Purchasing Company Contact",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToCompanyContactKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_purchasing_contact",
          },
        },
        configuration: {
          relatedModelKey: ShopifyCompanyContactKey,
        },
      },
      {
        name: "Purchasing Company Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToCompanyLocationKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_purchasing_location",
          },
        },
        configuration: {
          relatedModelKey: ShopifyCompanyLocationKey,
        },
      },
    ],
  },
  "2023-07": {
    fields: [
      {
        name: "Tax Exempt",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tax_exempt" } },
      },
      {
        name: "PO Number",
        customApiIdentifier: "poNumber",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "po_number" } },
      },
    ],
  },
  "2023-10": {
    fields: [
      {
        name: "Cancellation",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_order_cancellation",
            graphQLFieldKey: "cancellation",
            graphQLOnlyField: true,
            graphQLSelection: "staffNote",
          },
        },
      },
      {
        name: "Shopify Protect",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_order_shopify_protect",
            graphQLFieldKey: "shopifyProtect",
            graphQLOnlyField: true,
            graphQLSelection: `
            status
            eligibility {
              status
            }
            `,
          },
        },
      },
      {
        name: "Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToLocationKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "location_id", deprecated: true } },
        configuration: {
          relatedModelKey: ShopifyLocationKey,
        },
      },
    ],
  },
  "2024-01": {
    fields: [
      {
        name: "Payment Terms",
        fieldType: FieldType.HasOne,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "paymentTerms",
            graphQLOnlyField: true,
            graphQLSelection: `
            id
            dueInDays
            order {
              id
            }
            overdue
            paymentTermsName
            paymentTermsType
            translatedName
            `,
            shopifyFieldKey: "payment_terms",
          },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyPaymentTermsKey,
          inverseFieldKey: ShopifyPaymentTermsToOrderKey,
        },
      },
    ],
  },
  "2024-04": {
    fields: [
      {
        name: "Risks",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToOrderRisksKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            deprecated: true,
          },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyOrderRiskKey,
          inverseFieldKey: ShopifyOrderRiskToOrderKey,
        },
      },
      {
        name: "Risk",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_order_risk",
            graphQLFieldKey: "risk",
            graphQLOnlyField: true,
            graphQLSelection: `
            assessments {
              facts {
                description
                sentiment
              }
              provider {
                id
              }
              riskLevel
            }
            recommendation`,
          },
        },
      },
    ],
  },
  "2024-07": {
    fields: [
      {
        name: "Retail Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToRetailLocationKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_retail_location",
            graphQLFieldKey: "retailLocation",
            graphQLOnlyField: true,
            graphQLSelection: `
            id`,
          },
        },
        configuration: {
          relatedModelKey: ShopifyLocationKey,
        },
      },
      {
        name: "Fulfillments Count",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_fulfillments_count",
            graphQLFieldKey: "fulfillmentsCount",
            graphQLOnlyField: true,
            graphQLSelection: `
            count
            precision`,
          },
        },
      },
      {
        name: "Transactions Count",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_transactions_count",
            graphQLFieldKey: "transactionsCount",
            graphQLOnlyField: true,
            graphQLSelection: `
            count
            precision`,
          },
        },
      },
      {
        name: "Draft Order",
        fieldType: FieldType.HasOne,
        key: ShopifyOrderToDraftOrderKey,
        configuration: {
          relatedModelKey: ShopifyDraftOrderKey,
          inverseFieldKey: ShopifyDraftOrderToOrderKey,
        },
      },
      {
        name: "Returns",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToReturnsKey,
        configuration: {
          relatedModelKey: ShopifyReturnKey,
          inverseFieldKey: ShopifyReturnToOrderKey,
        },
      },
      {
        name: "Reverse Fulfillment Orders",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToReverseFulfillmentOrdersKey,
        configuration: {
          relatedModelKey: ShopifyReverseFulfillmentOrderKey,
          inverseFieldKey: ShopifyReverseFulfillmentOrderToOrderKey,
        },
      },
    ],
  },
  "2024-10": {
    fields: [
      {
        name: "Total Cash Rounding Adjustment",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_total_cash_rounding_adjustment",
            graphQLFieldKey: "totalCashRoundingAdjustment",
            graphQLOnlyField: true,
            graphQLSelection: `
            paymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
            refundSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
            `,
          },
        },
      },
      {
        name: "Status Page URL",
        fieldType: FieldType.URL,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_status_page_url",
            graphQLFieldKey: "statusPageUrl",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Business Entity",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToBusinessEntityKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_merchant_business_entity",
            graphQLFieldKey: "merchantBusinessEntity",
            graphQLOnlyField: true,
            graphQLSelection: `
            id
            companyName
            displayName
            primary
            address {
              address1
              address2
              city
              countryCode
              province
              zip
            }
            `,
          },
        },
        configuration: {
          relatedModelKey: ShopifyBusinessEntityKey,
        },
      },
    ],
  },
  "2025-04": {
    fields: [
      {
        name: "Adjustments",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToOrderAdjustmentsKey,
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyOrderAdjustmentKey,
          inverseFieldKey: ShopifyOrderAdjustmentToOrderKey,
        },
      },
      {
        name: "Balance Transactions",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToBalanceTransactionsKey,
        configuration: {
          relatedModelKey: ShopifyBalanceTransactionKey,
          inverseFieldKey: ShopifyBalanceTransactionToOrderKey,
        },
      },
      {
        name: "Billing Address",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "billing_address",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "billingAddress",
            graphQLSelection: `
          firstName
          address1
          phone
          city
          zip
          province
          country
          lastName
          address2
          company
          latitude
          longitude
          name
          countryCodeV2
          provinceCode
          `,
            protectedCustomerData: ["name", "address", "phone"],
          },
        },
      },
      {
        name: "Browser IP",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "browser_ip",
            graphQLFieldKey: "clientIp",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Buyer Accepts Marketing",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "buyer_accepts_marketing",
            graphQLFieldKey: "customerAcceptsMarketing",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Cancel Reason",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "cancel_reason",
            graphQLFieldKey: "cancelReason",
            isShopifyEnum: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [
            { name: "CUSTOMER" },
            { name: "DECLINED" },
            { name: "FRAUD" },
            { name: "INVENTORY" },
            { name: "OTHER" },
            { name: "STAFF" },
          ],
        },
      },
      {
        name: "Cancelled At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "cancelled_at",
            graphQLFieldKey: "cancelledAt",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Cart Token",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "cart_token",
            deprecated: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Checkout Token",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "checkout_token",
            deprecated: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Client Details",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "client_details",
            deprecated: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Closed At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "closed_at",
            graphQLFieldKey: "closedAt",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Currency",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "currency",
            graphQLFieldKey: "currencyCode",
            isShopifyEnum: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: shopifyCurrencyCodeEnumOptions,
        },
      },
      {
        name: "Current Subtotal Price",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "current_subtotal_price",
            graphQLFieldKey: "currentSubtotalPrice",
            skipGraphQLSelection: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Current Subtotal Price Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "current_subtotal_price_set",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "currentSubtotalPriceSet",
            graphQLSelection: `
          shopMoney {
            amount
            currencyCode
          }
          presentmentMoney {
            amount
            currencyCode
          }
          `,
          },
        },
      },
      {
        name: "Current Total Discounts",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "current_total_discounts",
            graphQLFieldKey: "currentTotalDiscounts",
            skipGraphQLSelection: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Current Total Discounts Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "current_total_discounts_set",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "currentTotalDiscountsSet",
            graphQLSelection: `
          shopMoney {
            amount
            currencyCode
          }
          presentmentMoney {
            amount
            currencyCode
          }
          `,
          },
        },
      },
      {
        name: "Current Total Duties Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "current_total_duties_set",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "currentTotalDutiesSet",
            graphQLSelection: `
          shopMoney {
            amount
            currencyCode
          }
          presentmentMoney {
            amount
            currencyCode
          }
          `,
          },
        },
      },
      {
        name: "Current Total Price",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "current_total_price",
            graphQLFieldKey: "currentTotalPrice",
            skipGraphQLSelection: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Current Total Price Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "current_total_price_set",
            graphQLFieldKey: "currentTotalPriceSet",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLSelection: `
          shopMoney {
            amount
            currencyCode
          }
          presentmentMoney {
            amount
            currencyCode
          }
          `,
          },
        },
      },
      {
        name: "Current Total Tax",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "current_total_tax",
            graphQLFieldKey: "currentTotalTax",
            skipGraphQLSelection: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Current Total Tax Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "current_total_tax_set",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "currentTotalTaxSet",
            graphQLSelection: `
          shopMoney {
            amount
            currencyCode
          }
          presentmentMoney {
            amount
            currencyCode
          }
          `,
          },
        },
      },
      {
        name: "Customer",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToCustomerKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "customer",
            graphQLFieldKey: "customer",
            graphQLSelection: "id",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
        configuration: {
          relatedModelKey: ShopifyCustomerKey,
        },
      },
      {
        name: "Customer Locale",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "customer_locale",
            graphQLFieldKey: "customerLocale",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Discount Applications",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "discount_applications", availableInWebhook: ["orders/create", "orders/updated"] },
        },
      },
      {
        name: "Discount Codes",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "discount_codes",
            graphQLFieldKey: "discountCodes",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Disputes",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToDisputesKey,
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyDisputeKey,
          inverseFieldKey: ShopifyDisputeToOrderKey,
        },
      },
      {
        name: "Email",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "email",
            graphQLFieldKey: "email",
            protectedCustomerData: ["email"],
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Estimated Taxes",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "estimated_taxes",
            graphQLFieldKey: "estimatedTaxes",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Financial Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "financial_status",
            graphQLFieldKey: "displayFinancialStatus",
            isShopifyEnum: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [
            { name: "AUTHORIZED" },
            { name: "EXPIRED" },
            { name: "PAID" },
            { name: "PARTIALLY_PAID" },
            { name: "PARTIALLY_REFUNDED" },
            { name: "PENDING" },
            { name: "REFUNDED" },
            { name: "VOIDED" },
          ],
        },
      },
      {
        name: "Fulfillment Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "fulfillment_status",
            graphQLFieldKey: "displayFulfillmentStatus",
            isShopifyEnum: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [
            { name: "FULFILLED" },
            { name: "IN_PROGRESS" },
            { name: "ON_HOLD" },
            { name: "OPEN" },
            { name: "PARTIALLY_FULFILLED" },
            { name: "PENDING_FULFILLMENT" },
            { name: "REQUEST_DECLINED" },
            { name: "RESTOCKED" },
            { name: "SCHEDULED" },
            { name: "UNFULFILLED" },
          ],
        },
      },
      {
        name: "Fulfillments",
        fieldType: FieldType.HasMany,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "fulfillments",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
        configuration: {
          relatedModelKey: ShopifyFulfillmentKey,
          inverseFieldKey: ShopifyFulfillmentToOrderKey,
        },
      },
      {
        name: "Fulfillment Events",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToFulfillmentEventsKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentEventKey,
          inverseFieldKey: ShopifyFulfillmentEventToOrderKey,
        },
      },
      {
        name: "Fulfillment Orders",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToFulfillmentOrdersKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentOrderKey,
          inverseFieldKey: ShopifyFulfillmentOrderToOrderKey,
        },
      },
      {
        name: "Gift Cards",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToGiftCardsKey,
        configuration: {
          relatedModelKey: ShopifyGiftCardKey,
          inverseFieldKey: ShopifyGiftCardToOrderKey,
        },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "id",
            graphQLFieldKey: "id",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Landing Site",
        fieldType: FieldType.URL,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "landing_site",
            deprecated: true,
            graphQLFieldKey: "landingPageUrl",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Line Items",
        fieldType: FieldType.HasMany,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "line_items", availableInWebhook: ["orders/create", "orders/updated"] },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyOrderLineItemKey,
          inverseFieldKey: ShopifyOrderLineItemToOrderKey,
        },
      },
      {
        name: "Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToLocationKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "location_id",
            graphQLFieldKey: "physicalLocation",
            graphQLSelection: "id",
            deprecated: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
        configuration: {
          relatedModelKey: ShopifyLocationKey,
        },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "name",
            graphQLFieldKey: "name",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Note",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "note",
            graphQLFieldKey: "note",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Note Attributes",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "note_attributes",
            graphQLFieldKey: "customAttributes",
            graphQLSelection: `
          key
          value
          `,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Number",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "number" } },
        isDeleted: true,
      },
      {
        name: "Order Number",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "order_number" } },
        isDeleted: true,
      },
      {
        name: "Order Status URL",
        fieldType: FieldType.URL,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "order_status_url",
            graphQLFieldKey: "statusPageUrl",
            protectedCustomerData: ["name", "email", "address", "phone"],
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Original Total Duties Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "original_total_duties_set",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "originalTotalDutiesSet",
            graphQLSelection: `
          shopMoney {
            amount
            currencyCode
          }
          presentmentMoney {
            amount
            currencyCode
          }
          `,
          },
        },
      },
      {
        name: "Payment Gateway Names",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "payment_gateway_names",
            graphQLFieldKey: "paymentGatewayNames",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Phone",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "phone",
            graphQLFieldKey: "phone",
            protectedCustomerData: ["phone"],
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Presentment Currency",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "presentment_currency",
            graphQLFieldKey: "presentmentCurrencyCode",
            isShopifyEnum: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: shopifyCurrencyCodeEnumOptions,
        },
      },
      {
        name: "Processed At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "processed_at",
            graphQLFieldKey: "processedAt",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Processing Method",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "processing_method" } },
      },
      {
        name: "Referring Site",
        fieldType: FieldType.URL,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "referring_site",
            graphQLFieldKey: "referrerUrl",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Refunds",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToRefundsKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "refunds",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyRefundKey,
          inverseFieldKey: ShopifyRefundToOrderKey,
        },
      },
      {
        name: "Risks",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToOrderRisksKey,
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyOrderRiskKey,
          inverseFieldKey: ShopifyOrderRiskToOrderKey,
        },
      },
      {
        name: "Shipping Address",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "shipping_address",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "shippingAddress",
            graphQLSelection: `
          firstName
          address1
          phone
          city
          zip
          province
          country
          lastName
          address2
          company
          latitude
          longitude
          name
          countryCodeV2
          provinceCode
          `,
            protectedCustomerData: ["name", "address", "phone"],
          },
        },
      },
      {
        name: "Shipping Lines",
        fieldType: FieldType.HasMany,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "shipping_lines", availableInWebhook: ["orders/create", "orders/updated"] },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyShippingLineKey,
          inverseFieldKey: ShopifyShippingLineToOrderKey,
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "created_at",
            graphQLFieldKey: "createdAt",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "updated_at",
            graphQLFieldKey: "updatedAt",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Source Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "source_name",
            graphQLFieldKey: "sourceName",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Subscription Billing Attempts",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToSubscriptionBillingAttemptKey,
        configuration: {
          relatedModelKey: ShopifySubscriptionBillingAttemptKey,
          inverseFieldKey: ShopifySubscriptionBillingAttemptToOrderKey,
        },
      },
      {
        name: "Subscription Contract",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToSubscriptionContractKey,
        configuration: {
          relatedModelKey: ShopifySubscriptionContractKey,
        },
      },
      {
        name: "Subtotal Price",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "subtotal_price",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "subtotalPrice",
            skipGraphQLSelection: true,
          },
        },
      },
      {
        name: "Subtotal Price Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "subtotal_price_set",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "subtotalPriceSet",
            graphQLSelection: `
          shopMoney {
            amount
            currencyCode
          }
          presentmentMoney {
            amount
            currencyCode
          }
          `,
          },
        },
      },
      {
        name: "Tags",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "tags",
            graphQLFieldKey: "tags",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Tax Lines",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "tax_lines",
            graphQLFieldKey: "taxLines",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLSelection: `
          price
          priceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
          rate
          title
          channelLiable
          `,
          },
        },
      },
      {
        name: "Taxes Included",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "taxes_included",
            graphQLFieldKey: "taxesIncluded",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Test",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "test",
            graphQLFieldKey: "test",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Token",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "token", deprecated: true, availableInWebhook: ["orders/create", "orders/updated"] },
        },
      },
      {
        name: "Total Discounts",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "total_discounts",
            graphQLFieldKey: "totalDiscounts",
            skipGraphQLSelection: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Total Discounts Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "total_discounts_set",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "totalDiscountsSet",
            graphQLSelection: `
          shopMoney {
            amount
            currencyCode
          }
          presentmentMoney {
            amount
            currencyCode
          }
          `,
          },
        },
      },
      {
        name: "Total Line Items Price",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "total_line_items_price",
            deprecated: true,
            graphQLFieldKey: "totalLineItemsPrice",
            skipGraphQLSelection: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Total Line Items Price Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "total_line_items_price_set",
            graphQLFieldKey: "totalLineItemsPriceSet",
            skipGraphQLSelection: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Total Outstanding",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "total_outstanding",
            graphQLFieldKey: "totalOutstanding",
            skipGraphQLSelection: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Total Price",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "total_price",
            graphQLFieldKey: "totalPrice",
            skipGraphQLSelection: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Total Price Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "total_price_set",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "totalPriceSet",
            graphQLSelection: `
          shopMoney {
            amount
            currencyCode
          }
          presentmentMoney {
            amount
            currencyCode
          }
          `,
          },
        },
      },
      {
        name: "Total Shipping Price Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "total_shipping_price_set",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "totalShippingPriceSet",
            graphQLSelection: `
          shopMoney {
            amount
            currencyCode
          }
          presentmentMoney {
            amount
            currencyCode
          }
          `,
          },
        },
      },
      {
        name: "Total Tax",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "total_tax",
            graphQLFieldKey: "totalTax",
            skipGraphQLSelection: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Total Tax Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "total_tax_set",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "totalTaxSet",
            graphQLSelection: `
          shopMoney {
            amount
            currencyCode
          }
          presentmentMoney {
            amount
            currencyCode
          }
          `,
          },
        },
      },
      {
        name: "Total Tip Received",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "total_tip_received",
            graphQLFieldKey: "totalTipReceived",
            skipGraphQLSelection: true,
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Total Weight",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "total_weight",
            graphQLFieldKey: "totalWeight",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Tender Transactions",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToTenderTransactionsKey,
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyTenderTransactionKey,
          inverseFieldKey: ShopifyTenderTransactionToOrderKey,
        },
      },
      {
        name: "Transactions",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToTransactionsKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "transactions",
            inheritSelectionFrom: ShopifyOrderTransactionKey,
            selectForHasMany: true,
            protectedCustomerData: ["name"],
          },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyOrderTransactionKey,
          inverseFieldKey: ShopifyOrderTransactionToOrderKey,
        },
      },
      {
        name: "Checkouts",
        fieldType: FieldType.HasMany,
        key: ShopifyOrderToCheckoutsKey,
        configuration: {
          relatedModelKey: ShopifyCheckoutKey,
          inverseFieldKey: ShopifyCheckoutToOrderKey,
        },
      },
      {
        name: "Source Identifier",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "source_identifier",
            graphQLFieldKey: "sourceIdentifier",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Source URL",
        fieldType: FieldType.URL,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "source_url",
            graphQLFieldKey: "registeredSourceUrl",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Merchant of Record App Id",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "merchant_of_record_app_id",
            graphQLFieldKey: "merchantOfRecordApp",
            graphQLSelection: "id",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Current Total Additional Fees Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "current_total_additional_fees_set",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "currentTotalAdditionalFeesSet",
            graphQLSelection: `
          shopMoney {
            amount
            currencyCode
          }
          presentmentMoney {
            amount
            currencyCode
          }
          `,
          },
        },
      },
      {
        name: "Original Total Additional Fees Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "original_total_additional_fees_set",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "originalTotalAdditionalFeesSet",
            graphQLSelection: `
          shopMoney {
            amount
            currencyCode
          }
          presentmentMoney {
            amount
            currencyCode
          }
          `,
          },
        },
      },
      // TODO decide if we want to frankensync graphql only fields or let users handle it themselves on webhook, or run force sync
      {
        name: "Additional Fees",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_additional_fees",
            graphQLFieldKey: "additionalFees",
            graphQLOnlyField: true,
            graphQLSelection: `
            id
            name
            price {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
            taxLines {
              channelLiable
              priceSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
                shopMoney {
                  amount
                  currencyCode
                }
              }
              rate
              ratePercentage
              title
            }`,
          },
        },
      },
      {
        name: "Purchasing Entity",
        fieldType: FieldType.JSON,
        shouldConvergeField: (enabledModelKeys) =>
          enabledModelKeys.some((key) => [ShopifyCompanyKey, ShopifyCompanyLocationKey, ShopifyCompanyContactKey].includes(key)),
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLOnlyField: true,
            shopifyFieldKey: "__gadget_graphql_purchasing_entity",
            graphQLFieldKey: "purchasingEntity",
            graphQLSelection: `
              ... on PurchasingCompany {
                company {
                  id
                }
                contact {
                  id
                }
                location {
                  id
                }
              }
              ... on Customer {
                id
              }
            `,
          },
        },
      },
      {
        name: "Purchasing Company",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToCompanyKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_purchasing_company",
            graphQLFieldKey: "purchasingCompany",
            skipGraphQLSelection: true,
          },
        },
        configuration: {
          relatedModelKey: ShopifyCompanyKey,
        },
      },
      {
        name: "Purchasing Company Contact",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToCompanyContactKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_purchasing_contact",
            graphQLFieldKey: "purchasingCompanyContact",
            skipGraphQLSelection: true,
          },
        },
        configuration: {
          relatedModelKey: ShopifyCompanyContactKey,
        },
      },
      {
        name: "Purchasing Company Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToCompanyLocationKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_purchasing_location",
            graphQLFieldKey: "purchasingCompanyLocation",
            skipGraphQLSelection: true,
          },
        },
        configuration: {
          relatedModelKey: ShopifyCompanyLocationKey,
        },
      },
      {
        name: "Tax Exempt",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "tax_exempt",
            graphQLFieldKey: "taxExempt",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "PO Number",
        customApiIdentifier: "poNumber",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "po_number",
            graphQLFieldKey: "poNumber",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      // TODO decide on these frankensyncs
      {
        name: "Cancellation",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_order_cancellation",
            graphQLFieldKey: "cancellation",
            graphQLOnlyField: true,
            graphQLSelection: "staffNote",
          },
        },
      },
      {
        name: "Shopify Protect",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_order_shopify_protect",
            graphQLFieldKey: "shopifyProtect",
            graphQLOnlyField: true,
            graphQLSelection: `
            status
            eligibility {
              status
            }
            `,
          },
        },
      },
      {
        name: "Payment Terms",
        fieldType: FieldType.HasOne,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "paymentTerms",
            graphQLOnlyField: true,
            graphQLSelection: `
            id
            dueInDays
            order {
              id
            }
            overdue
            paymentTermsName
            paymentTermsType
            translatedName
            `,
            shopifyFieldKey: "payment_terms",
          },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyPaymentTermsKey,
          inverseFieldKey: ShopifyPaymentTermsToOrderKey,
        },
      },
      {
        name: "Risks",
        fieldType: FieldType.HasMany,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            deprecated: true,
          },
        },
        isDeleted: true,
      },
      {
        name: "Risk",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_order_risk",
            graphQLFieldKey: "risk",
            graphQLOnlyField: true,
            graphQLSelection: `
            assessments {
              facts {
                description
                sentiment
              }
              provider {
                id
              }
              riskLevel
            }
            recommendation`,
          },
        },
      },
      {
        name: "Retail Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToRetailLocationKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_retail_location",
            graphQLFieldKey: "retailLocation",
            graphQLOnlyField: true,
            graphQLSelection: `
            id`,
          },
        },
        configuration: {
          relatedModelKey: ShopifyLocationKey,
        },
      },
      {
        name: "Fulfillments Count",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_fulfillments_count",
            graphQLFieldKey: "fulfillmentsCount",
            graphQLOnlyField: true,
            graphQLSelection: `
            count
            precision`,
          },
        },
      },
      {
        name: "Transactions Count",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_transactions_count",
            graphQLFieldKey: "transactionsCount",
            graphQLOnlyField: true,
            graphQLSelection: `
            count
            precision`,
          },
        },
      },
      {
        name: "Draft Order",
        fieldType: FieldType.HasOne,
        key: ShopifyOrderToDraftOrderKey,
        configuration: {
          relatedModelKey: ShopifyDraftOrderKey,
          inverseFieldKey: ShopifyDraftOrderToOrderKey,
        },
      },
      {
        name: "Total Cash Rounding Adjustment",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_total_cash_rounding_adjustment",
            graphQLFieldKey: "totalCashRoundingAdjustment",
            graphQLOnlyField: true,
            graphQLSelection: `
            paymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
            refundSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
            `,
          },
        },
      },
      {
        name: "Status Page URL",
        fieldType: FieldType.URL,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_status_page_url",
            graphQLFieldKey: "statusPageUrl",
            graphQLOnlyField: true,
          },
        },
        isDeleted: true,
      },
      {
        name: "Business Entity",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderToBusinessEntityKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_merchant_business_entity",
            graphQLFieldKey: "merchantBusinessEntity",
            graphQLOnlyField: true,
            graphQLSelection: `
            id
            companyName
            displayName
            primary
            address {
              address1
              address2
              city
              countryCode
              province
              zip
            }
            `,
          },
        },
        configuration: {
          relatedModelKey: ShopifyBusinessEntityKey,
        },
      },
      {
        name: "Billing Status Matches Shipping Address",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "billingAddressMatchesShippingAddress",
          },
        },
      },
      {
        name: "Alerts",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "alerts",
            graphQLOnlyField: true,
            graphQLSelection: `
            actions {
              primary
              show
              title
              url
            }
            content
            dismissibleHandle
            icon
            severity
            title
            `,
          },
        },
      },
      {
        name: "Can Mark As Paid",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "canMarkAsPaid",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Can Notify Customer",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "canNotifyCustomer",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Capturable",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "capturable",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Cart Discount Amount Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "cartDiscountAmountSet",
            graphQLOnlyField: true,
            graphQLSelection: `
            shopMoney {
              amount
              currencyCode
            }
            presentmentMoney {
              amount
              currencyCode
            }
            `,
          },
        },
      },
      {
        name: "Closed",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "closed",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Confirmation Number",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "confirmation_number",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "confirmationNumber",
          },
        },
      },
      {
        name: "Confirmed",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "confirmed",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "confirmed",
          },
        },
      },
      {
        name: "Current Cart Discount Amount Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "currentCartDiscountAmountSet",
            graphQLOnlyField: true,
            graphQLSelection: `
            shopMoney {
              amount
              currencyCode
            }
            presentmentMoney {
              amount
              currencyCode
            }
            `,
          },
        },
      },
      {
        name: "Current Shipping Price Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "current_shipping_price_set",
            availableInWebhook: ["orders/create", "orders/updated"],
            graphQLFieldKey: "currentShippingPriceSet",
            graphQLSelection: `
            shopMoney {
              amount
              currencyCode
            }
            presentmentMoney {
              amount
              currencyCode
            }
            `,
          },
        },
      },
      {
        name: "Current Subtotal Line Items Quantity",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "currentSubtotalLineItemsQuantity",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Current Total Weight",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "currentTotalWeight",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Duties Included",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "duties_included",
            graphQLFieldKey: "dutiesIncluded",
            availableInWebhook: ["orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Edited",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "edited",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Fulfillable",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "fulfillable",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Fully Paid",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "fullyPaid",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Has Timeline Comment",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "hasTimelineComment",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Legacy Resource Id",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "legacyResourceId",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Merchant Editable",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "merchantEditable",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Merchant Editable Errors",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "merchantEditableErrors",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Net Payment Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "netPaymentSet",
            graphQLOnlyField: true,
            graphQLSelection: `
            shopMoney {
              amount
              currencyCode
            }
            presentmentMoney {
              amount
              currencyCode
            }
            `,
          },
        },
      },
      {
        name: "Original Total Price Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "originalTotalPriceSet",
            graphQLOnlyField: true,
            graphQLSelection: `
            shopMoney {
              amount
              currencyCode
            }
            presentmentMoney {
              amount
              currencyCode
            }
            `,
          },
        },
      },
      {
        name: "Refundable",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "refundable",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Refund Discrepency Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "refundDiscrepancySet",
            graphQLOnlyField: true,
            graphQLSelection: `
            shopMoney {
              amount
              currencyCode
            }
            presentmentMoney {
              amount
              currencyCode
            }
            `,
          },
        },
      },
      {
        name: "Requires Shipping",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "requiresShipping",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Restockable",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "restockable",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Return Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "returnStatus",
            graphQLOnlyField: true,
            isShopifyEnum: true,
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [
            { name: "INSPECTION_COMPLETE" },
            { name: "IN_PROGRESS" },
            { name: "NO_RETURN" },
            { name: "RETURNED" },
            { name: "RETURN_FAILED" },
            { name: "RETURN_REQUESTED" },
          ],
        },
      },
      {
        name: "Total Capturable Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "totalCapturableSet",
            graphQLOnlyField: true,
            graphQLSelection: `
            shopMoney {
              amount
              currencyCode
            }
            presentmentMoney {
              amount
              currencyCode
            }
            `,
          },
        },
      },
      {
        name: "Total Outstanding Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "totalOutstandingSet",
            graphQLOnlyField: true,
            graphQLSelection: `
            shopMoney {
              amount
              currencyCode
            }
            presentmentMoney {
              amount
              currencyCode
            }
            `,
          },
        },
      },
      {
        name: "Total Received Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "totalReceivedSet",
            graphQLOnlyField: true,
            graphQLSelection: `
            shopMoney {
              amount
              currencyCode
            }
            presentmentMoney {
              amount
              currencyCode
            }
            `,
          },
        },
      },
      {
        name: "Total Refunded Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "totalRefundedSet",
            graphQLOnlyField: true,
            graphQLSelection: `
            shopMoney {
              amount
              currencyCode
            }
            presentmentMoney {
              amount
              currencyCode
            }
            `,
          },
        },
      },
      {
        name: "Total Refunded Shipping Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "totalRefundedShippingSet",
            graphQLOnlyField: true,
            graphQLSelection: `
            shopMoney {
              amount
              currencyCode
            }
            presentmentMoney {
              amount
              currencyCode
            }
            `,
          },
        },
      },
      {
        name: "Total Tip Received Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "totalTipReceivedSet",
            graphQLOnlyField: true,
            graphQLSelection: `
            shopMoney {
              amount
              currencyCode
            }
            presentmentMoney {
              amount
              currencyCode
            }
            `,
          },
        },
      },
      {
        name: "Unpaid",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "unpaid",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Customer Journey Summary",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "customerJourneySummary",
            graphQLOnlyField: true,
            graphQLSelection: `
            customerOrderIndex
            daysToConversion
            firstVisit {
              id
              landingPage
              occurredAt
              referralCode
              referrerUrl
              source
              sourceDescription
              sourceType
              utmParameters {
                campaign
                content
                medium
                source
                term
              }
            }
            lastVisit {
              id
              landingPage
              occurredAt
              referralCode
              referrerUrl
              source
              sourceDescription
              sourceType
              utmParameters {
                campaign
                content
                medium
                source
                term
              }
            }
            momentsCount {
              count
              precision
            }
            ready
            `,
          },
        },
      },
    ],
    syncConfig: {
      type: "graphql_list",
      resource: "orders",
      filters: {
        updatedAt: { sortKey: "UPDATED_AT" },
        createdAt: { sortKey: "CREATED_AT" },
      },
      sortableBy: {
        updatedAt: { sortKey: "UPDATED_AT", reverse: true },
        createdAt: { sortKey: "CREATED_AT", reverse: true },
        customerName: { sortKey: "CUSTOMER_NAME", reverse: false },
        destination: { sortKey: "DESTINATION", reverse: false },
        financialStatus: { sortKey: "FINANCIAL_STATUS", reverse: false },
        fulfillmentStatus: { sortKey: "FULFILLMENT_STATUS", reverse: false },
        id: { sortKey: "ID", reverse: false },
        orderNumber: { sortKey: "ORDER_NUMBER", reverse: true },
        poNumber: { sortKey: "PO_NUMBER", reverse: false },
        processedAt: { sortKey: "PROCESSED_AT", reverse: true },
        relevance: { sortKey: "RELEVANCE", reverse: false },
        totalItemsQuantity: { sortKey: "TOTAL_ITEMS_QUANTITY", reverse: true },
        totalPrice: { sortKey: "TOTAL_PRICE", reverse: true },
      },
    },
  },
};

export const ShopifyOrder = ({
  apiVersion,
  frameworkVersionConstraint,
  webhookTopicsForModel,
  withDefaultFieldsOnly,
  existingShopifyModelKeys,
  requestedScopes,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
  webhookTopicsForModel?: string[];
  withDefaultFieldsOnly?: boolean;
  existingShopifyModelKeys?: string[];
  requestedScopes?: string[];
}) =>
  buildConnectionSpec(
    specs,
    apiVersion,
    frameworkVersionConstraint,
    webhookTopicsForModel,
    withDefaultFieldsOnly,
    existingShopifyModelKeys,
    requestedScopes
  );
